import { Session } from 'smg/customer-api/session';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import { GetFirstAndLast } from 'smg/users';
import { Input } from 'smg/customer-api/promos';

import * as buttons from 'smg/buttons';
import * as countries from 'smg/countries';
import * as quoterequests from 'smg/customer-api/quoterequests';
import * as models from 'smg/models';

import * as luxon from 'luxon';

import { Uploader } from '../components/uploader';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

if (document.body.id === 'trading-pin-quote-form') {
    main();
}

function main() {
    const $form = document.querySelector<HTMLFormElement>('#main-form') as HTMLFormElement;
    const $sectionSport = $form.querySelector<HTMLDivElement>('#section-sport') as HTMLDivElement;
    const $sectionTemplate = $form.querySelector<HTMLDivElement>('#section-template') as HTMLDivElement;
    const $sectionSize = $form.querySelector<HTMLDivElement>('#section-size') as HTMLDivElement;
    const $sectionPlating = $form.querySelector<HTMLDivElement>('#section-plating') as HTMLDivElement;
    const $sectionUpgrades = $form.querySelector<HTMLDivElement>('#section-upgrades') as HTMLDivElement;
    const $sectionContact = $form.querySelector<HTMLDivElement>('#section-contact') as HTMLDivElement;

    const $fieldset = $form.querySelector<HTMLFieldSetElement>('#trading-quote-form-fieldset') as HTMLFieldSetElement;

    const $sportBaseball = $sectionSport.querySelector<HTMLInputElement>('#sport-baseball') as HTMLInputElement;
    const $sportSoftball = $sectionSport.querySelector<HTMLInputElement>('#sport-softball') as HTMLInputElement;

    const $tradingQuoteQuantity = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-quantity') as HTMLInputElement;
    const $tradingQuoteTeamName = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-team-name') as HTMLInputElement;
    const $tradingQuoteTeamColors = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-team-colors') as HTMLInputElement;
    const $tradingQuoteUploadLabel = $sectionContact.querySelector<HTMLLabelElement>('.uploader-dropzone') as HTMLLabelElement;
    const $tradingQuoteNotes = $sectionContact.querySelector<HTMLTextAreaElement>('#trading-quote-notes') as HTMLTextAreaElement;
    const $tradingQuoteName = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-name') as HTMLInputElement;
    const $tradingQuoteEmail = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-email') as HTMLInputElement;
    const $tradingQuotePhone = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-phone') as HTMLInputElement;
    const $tradingQuoteState = $sectionContact.querySelector<HTMLSelectElement>('#trading-quote-state') as HTMLSelectElement;
    const $tradingQuoteDate = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-date') as HTMLInputElement;
    const $tradingQuotePromo = $sectionContact.querySelector<HTMLInputElement>('#trading-quote-promo') as HTMLInputElement;

    const $promoCodeButton = document.querySelector('#promo-code-button') as HTMLButtonElement;
    const $promoCodeSuccess = document.querySelector('#promo-code-success') as HTMLElement;
    const $promoCodeTitle = $promoCodeSuccess.querySelector('#promo-code-title') as HTMLElement;
    const $promoCodeDescription = $promoCodeSuccess.querySelector('#promo-code-description') as HTMLElement;

    const $tradingQuoteFormSubmit = $form.querySelector<HTMLButtonElement>('#trading-quote-form-submit') as HTMLButtonElement;

    const uploader = new Uploader($tradingQuoteUploadLabel);
    const phone = new Phone($tradingQuotePhone);
    const promo = new Input($tradingQuotePromo, {
        success: p => {
            $promoCodeTitle.textContent = p.name;
            $promoCodeDescription.textContent = p.description;
            $promoCodeSuccess.classList.remove('d-none');
        },
        error: () => {
            $promoCodeSuccess.classList.add('d-none');
            $promoCodeTitle.textContent = '';
            $promoCodeDescription.textContent = '';
        },
    });

    countries.StateSelect(models.CountryID.COUNTRIES_UNITED_STATES, $tradingQuoteState).catch(HandleRequestError);

    setTimeout(() => {
        promo.Dirty = true;
        void promo.Check();
    });

    $promoCodeButton.addEventListener('click', async e => {
        e.preventDefault();
        await promo.Check();
    });

    $sectionSport.addEventListener('change', () => {
        if ($sectionSport.querySelector('input:checked')) {
            $sectionTemplate.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $sectionTemplate.addEventListener('change', () => {
        if ($sectionTemplate.querySelector('input:checked')) {
            $sectionSize.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $sectionSize.addEventListener('change', () => {
        if ($sectionSize.querySelector('input:checked')) {
            $sectionPlating.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $sectionPlating.addEventListener('change', () => {
        if ($sectionPlating.querySelector('input:checked')) {
            $sectionUpgrades.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    $tradingQuoteFormSubmit.addEventListener('click', e => {
        e.preventDefault();

        $tradingQuoteDate.setCustomValidity('');
        let date: luxon.DateTime | undefined;
        if ($tradingQuoteDate.value) {
            date = luxon.DateTime.fromISO($tradingQuoteDate.value);
            if (date <= luxon.DateTime.now().startOf('day')) {
                $tradingQuoteDate.setCustomValidity('The date must be in the future.');
            }
        }

        if (!ReportValidity($form)) {
            if ($sectionSport.querySelector('input.is-invalid')) {
                $sectionSport.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($tradingQuoteFormSubmit);
        const extras: quoterequests.Extra[] = [];
        if ($tradingQuoteTeamName.value) {
            extras.push({
                name: 'Team Name',
                value: $tradingQuoteTeamName.value,
            });
        }

        if ($tradingQuoteTeamColors.value) {
            extras.push({
                name: 'Team Colors',
                value: $tradingQuoteTeamColors.value,
            });
        }

        if ($sportBaseball.checked) {
            extras.push({
                name: 'Sport',
                value: 'Baseball',
            });
        } else if ($sportSoftball.checked) {
            extras.push({
                name: 'Sport',
                value: 'Softball',
            });
        }

        if ($tradingQuoteState.value) {
            extras.push({
                name: 'State',
                value: $tradingQuoteState.options[$tradingQuoteState.selectedIndex].text,
            });
        }

        const $selectedTemplate = $sectionTemplate.querySelector<HTMLInputElement>('input:checked');
        if ($selectedTemplate) {
            extras.push({
                name: 'Template',
                value: $selectedTemplate.value,
            });
        }

        let size;
        const $selectedSize = $sectionSize.querySelector<HTMLInputElement>('input:checked');
        if ($selectedSize) {
            size = $selectedSize.value;
        }

        let children: quoterequests.Child[] | undefined = [];

        const $selectedPlating = $sectionPlating.querySelector<HTMLInputElement>('input:checked');
        if ($selectedPlating) {
            children.push({
                child: 'Plating',
                option: $selectedPlating.value,
            });
        }

        if (!children.length) {
            children = undefined;
        }

        quoterequests.NewQuoteRequest({
            name: $tradingQuoteName.value,
            company: $tradingQuoteTeamName.value,
            phone,
            email: $tradingQuoteEmail.value,
            lineItem: 'Lapel Pins',
            type: 'Trading Pins',
            size,
            children,
            quantity: $tradingQuoteQuantity.value ? parseInt($tradingQuoteQuantity.value, 10) : undefined,
            promo: !promo.Dirty ? $tradingQuotePromo.value : undefined,
            project: `${new Date().getFullYear()} ${$tradingQuoteTeamName.value}`,
            dateNeeded: date?.toISODate() ?? undefined,
            notes: $tradingQuoteNotes.value || undefined,
            extras,
            uploader,
        }).then(async quoteRequest => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String($tradingQuoteName.value));
            dataLayer.push({
                'event': 'hs-module-quote-form-success',
                'userData': {
                    'email': sess?.email || $tradingQuoteEmail.value,
                    'phone': sess?.phone || await phone.Format(),
                    'firstName': sess?.firstName || firstName,
                    'lastName': sess?.lastName || lastName,
                },
                'transactionId': quoteRequest.id,
                'total': quoteRequest.quotes?.[0].cachedTotal,
            });
            window.location.href = `${Relref('/free-quote/thank-you')}?id=${quoteRequest.quotes?.[0].key ?? ''}`;
        }).catch(err => {
            HandleRequestError(err);
            $fieldset.disabled = false;
            buttons.Stop($tradingQuoteFormSubmit);
        });
        return;
    });
}
